"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Link_1 = __importDefault(require("shared/components/Link"));
var HudledLogo = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 40 : _b;
    return ((0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: { pathname: '/' }, target: "_self" }, { children: (0, jsx_runtime_1.jsx)("img", { src: end2end_1.IS_RECHARGLY ? '/rechargly-logo.svg' : '/hudled-logo-color.svg', alt: "".concat(end2end_1.IS_RECHARGLY ? 'Rechargly' : 'Hudled', "'s Logo"), height: end2end_1.IS_RECHARGLY ? 48 : height }) })));
};
exports.default = HudledLogo;
